import { StPropertyInsertWithEndpoint } from '@/hooks/staysApi/useCreateStaysProperties'
import { apiClient } from '@/lib/api/client'
import { StProperty, StPropertyUpdate } from '@/types'
import { IRepository } from './types'

class StPropertyRepository
  implements
    IRepository<StProperty, StPropertyInsertWithEndpoint, StPropertyUpdate>
{
  private static instance: StPropertyRepository
  private readonly endpoint: string

  constructor(endpoint: string = 'st-properties') {
    this.endpoint = endpoint
  }

  public static getInstance(): StPropertyRepository {
    if (!this.instance) {
      this.instance = new StPropertyRepository()
    }
    return this.instance
  }

  async getAll(_params?: unknown): Promise<StProperty[]> {
    return apiClient.invoke<StProperty[]>(this.endpoint, {
      method: 'GET',
    })
  }

  async getById(id: string): Promise<StProperty | null> {
    return apiClient.invoke<StProperty>(`${this.endpoint}?id=${id}`, {
      method: 'GET',
    })
  }

  async create(data: StPropertyInsertWithEndpoint): Promise<StProperty> {
    const { images, ...formDataWithoutImages } = data.data

    const bodyPayload = new FormData()
    const imagesMetadata = images
      .filter(({ file }) => !!file)
      .map(({ is_primary }) => ({
        is_primary,
      }))
    bodyPayload.append(
      'st_property',
      JSON.stringify(
        Object.assign({}, formDataWithoutImages, { imagesMetadata })
      )
    )
    images.forEach((image) => {
      if (image.file) {
        bodyPayload.append('images', image.file)
      }
    })
    return apiClient.invoke<StProperty>(data.endpoint || this.endpoint, {
      method: 'POST',
      body: bodyPayload,
    })
  }

  async update(id: string, data: StPropertyUpdate): Promise<StProperty> {
    return apiClient.invoke<StProperty>(this.endpoint, {
      method: 'PUT',
      body: { id, ...data },
    })
  }
}

export const stPropertyRepository = StPropertyRepository.getInstance()
